function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.522 15.453a1 1 0 0 0 0 1.094C6.23 22.218 10.701 25 16 25c5.3 0 9.77-2.782 13.478-8.453a1 1 0 0 0 0-1.094C25.771 9.782 21.3 7 16 7c-5.3 0-9.77 2.782-13.478 8.453zM.848 14.358C4.903 8.156 9.975 5 16 5c6.025 0 11.097 3.156 15.152 9.358a3 3 0 0 1 0 3.284C27.097 23.845 22.025 27 16 27 9.975 27 4.903 23.845.848 17.642a3 3 0 0 1 0-3.284zM16 22a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
});

var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "ffb11fcde08e5684d7d0bb0832e3112b.svg";
export { SvgView as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/view.svg
// module id = null
// module chunks = 